"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// TODO handle errors
var ContactForm =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(ContactForm, _React$Component);

  function ContactForm(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ContactForm);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ContactForm).call(this, props));
    _this.state = _this.createInitialState();
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSubmit = _this.handleSubmit.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ContactForm, [{
    key: "toUpperCase",
    value: function toUpperCase(label) {
      return label.slice(0, 1).toUpperCase() + label.slice(1);
    }
  }, {
    key: "createFieldGroups",
    value: function createFieldGroups(fields) {
      return fields.reduce(function (acc, _, i) {
        return i % 2 ? acc : [].concat((0, _toConsumableArray2["default"])(acc), [fields.slice(i, i + 2)]);
      }, []);
    }
  }, {
    key: "createInitialState",
    value: function createInitialState() {
      var _this$props = this.props,
          fields = _this$props.fields,
          termsCopy = _this$props.termsCopy;
      var formFieldState = fields.reduce(function (acc, _ref) {
        var label = _ref.label;
        return _objectSpread({}, acc, (0, _defineProperty2["default"])({}, label, ''));
      }, {});
      var additionalState = {
        hasSubmitted: false,
        hasError: false,
        loading: false
      };
      var acceptTermsState = termsCopy ? {
        acceptedTerms: false
      } : {};
      return _objectSpread({}, formFieldState, {}, additionalState, {}, acceptTermsState);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e, _ref2) {
      var name = _ref2.name,
          value = _ref2.value;
      this.setState((0, _defineProperty2["default"])({}, name, value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;

      var _this$state = this.state,
          hasSubmitted = _this$state.hasSubmitted,
          hasError = _this$state.hasError,
          theRest = (0, _objectWithoutProperties2["default"])(_this$state, ["hasSubmitted", "hasError"]);
      var onSubmit = this.props.onSubmit;
      this.setState({
        loading: true
      }, function () {
        return onSubmit(theRest).then(function () {
          _this2.setState({
            loading: false
          });
        });
      });
    }
  }, {
    key: "mapFieldToInput",
    value: function mapFieldToInput(field) {
      var showLabels = this.props.showLabels;
      var label = field.label,
          placeholder = field.placeholder,
          type = field.type,
          required = field.required;
      return _react["default"].createElement(_semanticUiReact.Form.Field, {
        required: required,
        key: label,
        name: label,
        label: showLabels ? this.toUpperCase(label) : '',
        placeholder: placeholder,
        control: type === 'input' ? _semanticUiReact.Input : _semanticUiReact.TextArea,
        value: this.state[label],
        onChange: this.handleChange
      });
    }
  }, {
    key: "mapFieldsToInputGroup",
    value: function mapFieldsToInputGroup(fields) {
      var _this3 = this;

      return _react["default"].createElement(_semanticUiReact.Form.Group, {
        widths: "equal",
        key: fields[0].label
      }, fields.map(function (field) {
        return _this3.mapFieldToInput(field);
      }));
    }
  }, {
    key: "renderForms",
    value: function renderForms() {
      var _this4 = this;

      var _this$props2 = this.props,
          fields = _this$props2.fields,
          inline = _this$props2.inline; // Create chunks of two forms per group

      var fieldGroups = this.createFieldGroups(fields); // Wrap fields with form components

      var formGroups = fieldGroups.map(function (fieldGroup) {
        return _this4.mapFieldsToInputGroup(fieldGroup);
      });
      var forms = fields.map(function (field) {
        return _this4.mapFieldToInput(field);
      });
      var fieldsWithForms = inline ? formGroups : forms;
      return _react["default"].createElement(_react["default"].Fragment, null, fieldsWithForms);
    }
  }, {
    key: "renderTOS",
    value: function renderTOS() {
      var termsCopy = this.props.termsCopy;
      var acceptTerms = this.state.acceptTerms;
      return termsCopy && _react["default"].createElement(_semanticUiReact.Form.Field, {
        control: _semanticUiReact.Checkbox,
        label: termsCopy,
        value: acceptTerms,
        onChange: this.handleChange
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props3 = this.props,
          header = _this$props3.header,
          subheader = _this$props3.subheader,
          centeredHeaders = _this$props3.centeredHeaders;
      return _react["default"].createElement(_react["default"].Fragment, null, header && _react["default"].createElement(_semanticUiReact.Header, {
        as: "h1",
        textAlign: centeredHeaders ? 'center' : 'left'
      }, header), subheader && _react["default"].createElement(_semanticUiReact.Header, {
        as: "h3",
        textAlign: centeredHeaders ? 'center' : 'left'
      }, subheader));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          buttonText = _this$props4.buttonText,
          className = _this$props4.className,
          fluidButton = _this$props4.fluidButton,
          withContainer = _this$props4.withContainer;
      var loading = this.state.loading;

      var form = _react["default"].createElement("div", {
        className: className
      }, _react["default"].createElement(_semanticUiReact.Form, {
        loading: loading
      }, this.renderHeader(), this.renderForms(), this.renderTOS(), _react["default"].createElement(_semanticUiReact.Button, {
        onClick: this.handleSubmit,
        primary: true,
        fluid: fluidButton
      }, buttonText)));

      return withContainer ? _react["default"].createElement(_semanticUiReact.Container, null, form) : {
        form: form
      };
    }
  }]);
  return ContactForm;
}(_react["default"].Component);

exports["default"] = ContactForm;
ContactForm.propTypes = {
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    placeholder: _propTypes["default"].string,
    type: _propTypes["default"].oneOf(['input', 'textarea'])
  })),
  buttonText: _propTypes["default"].string,
  centeredHeaders: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  fluidButton: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  inline: _propTypes["default"].bool,
  onSubmit: _propTypes["default"].func.isRequired,
  showLabels: _propTypes["default"].bool,
  subheader: _propTypes["default"].string,
  termsCopy: _propTypes["default"].string,
  withContainer: _propTypes["default"].bool
};
ContactForm.defaultProps = {
  fields: [{
    label: 'name',
    placeholder: 'Name',
    type: 'input',
    required: true
  }, {
    label: 'email',
    placeholder: 'you@gmail.com',
    type: 'input',
    required: true
  }, {
    label: 'message',
    placeholder: 'Message',
    type: 'textarea',
    required: false
  }],
  buttonText: 'Submit',
  centeredHeaders: false,
  className: '',
  fluidButton: false,
  header: '',
  inline: false,
  showLabels: false,
  subheader: '',
  termsCopy: '',
  withContainer: true
};
ContactForm.propOptions = {
  header: ['Contact Form', 'Contact Us'],
  termsCopy: ['Accept the Terms of Service', '']
};
ContactForm.dataPropsMap = {};